import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { observer } from 'mobx-react';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { AttendeeMappingFormViewModel } from './attendee-mapping-form.viewmodel';
import {
    CHANGE_MAPPING_TEXT,
    CURRENT_MAPPING_TEXT,
    PREFERRED_NAME_TEXT,
    REMOVE_MAPPING_TEXT
} from './attendee-mapping-form.texts';
import { EDIT_TEXT } from '../../../../../../constants/common-labels.constants';

const CurrentContactField = (props: {
    value: string;
    parensLabel?: MessageDescriptor;
}) => props.value ? (
    <div className='attendee-mapping-form__current-field' title={props.value}>
        {props.value}
        {props.parensLabel &&
            <span className='attendee-mapping-form__current-field-note'>
                {' '}(<FormattedMessage {...props.parensLabel} />)
            </span>
        }
    </div>
) : null;

export const CurrentMappingSection = observer(({ vm }: { vm: AttendeeMappingFormViewModel }) => (
    <FormField label={<FormattedMessage {...CURRENT_MAPPING_TEXT} />}>
        <div className='attendee-mapping-form__current'>
            <div className='attendee-mapping-form__current-details'>
                <div className='attendee-mapping-form__current-name'>
                    <CurrentContactField value={vm.mappedContact.firstName} />
                    <CurrentContactField value={vm.mappedContact.lastName} />
                </div>
                <CurrentContactField value={vm.mappedContact.preferredName} parensLabel={PREFERRED_NAME_TEXT} />
                <CurrentContactField value={vm.mappedContact.organizationName} />
                <CurrentContactField value={vm.mappedContact.primaryEmail} />
            </div>
            <div className='attendee-mapping-form__current-buttons'>
                {vm.hasEditRolodexContactPermission() &&
                    <DefaultButton
                        className='visible-while-hovered'
                        text={<FormattedMessage {...EDIT_TEXT} />}
                        onClick={() => vm.openEditRolodexContactPopup(vm.mappedContact.contactId)}
                        modifier='slim'
                    />
                }
                <DefaultButton
                    modifier='remove'
                    text={<FormattedMessage {...REMOVE_MAPPING_TEXT} />}
                    onClick={vm.requestRemoval}
                />
                <DefaultButton
                    modifier='slim'
                    text={<FormattedMessage {...CHANGE_MAPPING_TEXT} />}
                    onClick={vm.requestChange}
                />
            </div>
        </div>
    </FormField>
));
